const FooterCredit = () => {
  return (
    <article className="credit">
      ©2022 | Designed and built by Alba Vidal.
    </article>
  );
};
export default FooterCredit;
